import { MapPin } from "lucide-react";
import { COUNTIES, COUNTY_IMAGES } from "../lib/funnelData";
import { Reveal } from "./Reveal";

export const Counties = ({ activeCounty, onSelect }) => (
  <section className="relative bg-gradient-to-b from-canvas via-surface to-canvas" data-testid="counties-served">
    <div className="absolute inset-0 pattern-contour" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <Reveal className="max-w-2xl">
        <span className="badge-brand">Where we work</span>
        <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-serif text-emeraldx-deep [text-wrap:balance]">County-deep knowledge, Upstate-wide reach</h2>
        <span className="rule-gold mt-6" />
        <p className="mt-4 text-base text-stone-600 [text-wrap:pretty]">From Lake Keowee frontage in Oconee to working farms in Abbeville and in-town homes in Anderson, I track what's actually selling in each of these nine counties. Select yours and I'll tailor your valuation to that market.</p>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(COUNTIES).map(([key, c], i) => (
          <Reveal key={key} delay={(i % 3) * 0.08}>
            <button
              type="button"
              data-testid={`county-card-${key}`}
              onClick={() => onSelect(key)}
              className={`group w-full text-left rounded-md border overflow-hidden bg-white transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(27,26,24,0.4)] active:scale-[0.98] ${
                activeCounty === key ? "border-oak ring-2 ring-oak/40" : "border-emeraldx-deep/10"
              }`}
            >
              <div className="relative h-28 overflow-hidden">
                <img src={COUNTY_IMAGES[key]} alt={`${c.name} County`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                {activeCounty === key && (
                  <span className="absolute top-2.5 right-2.5 text-[10px] font-mono uppercase tracking-[0.2em] px-2.5 py-1 bg-oak text-white">Selected</span>
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2.5">
                  <MapPin size={16} className="text-oak shrink-0" />
                  <span className="text-lg font-serif text-emeraldx-deep">{c.name} County</span>
                </div>
                <p className="mt-1.5 text-sm text-stone-500 leading-relaxed">{c.blurb}</p>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
